import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ServicesSection } from '../components/sections/ServicesSection';
import { FaqSection } from '../components/sections/FaqSection';
import { PageHeader } from '../components/sections/PageHeader';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import '../styles/home.css';

const BOOKING_URL = 'https://perfactive.fr/laura-body/new?people=26749';

export default function ServicesPage() {
  return (
    <div className="home-container">
      <Helmet>
        <title>Services - Laura Body Naturopathe et Réflexologue à Angoulême</title>
        <meta name="description" content="Découvrez les soins proposés par Laura Body à Angoulême : naturopathie, réflexologie plantaire, massage Shirotchampi et Massage Rose Équilibre. Accompagnement naturel et personnalisé." />
        <link rel="canonical" href="https://www.naturopathe-angouleme.fr/services" />
      </Helmet>

      <PageHeader />

      <section className="page-hero-mini">
        <div className="section-container">
          <Link to="/" className="back-link"><ArrowLeft size={16} /> Retour à l'accueil</Link>
          <h1 className="page-hero-title">Les Soins de Laura Body à Angoulême</h1>
          <p className="page-hero-description">
            Laura Body, naturopathe et réflexologue à Angoulême, vous propose des soins naturels personnalisés : massage bien-être, réflexologie plantaire, naturopathie et Massage Rose Équilibre.
          </p>
        </div>
      </section>

      <ServicesSection />
      <FaqSection />

      <section className="page-cta-section">
        <div className="section-container" style={{textAlign: 'center'}}>
          <h2 className="section-title">Prendre rendez-vous avec Laura Body</h2>
          <p style={{marginBottom: '2rem', color: '#666'}}>Réservez votre séance de naturopathie, réflexologie ou massage à Angoulême</p>
          <a href={BOOKING_URL} target="_blank">
            <Button className="btn-primary-hero">Réserver maintenant</Button>
          </a>
        </div>
      </section>
    </div>
  );
}
